import { render, staticRenderFns } from "./ReturnRefund.vue?vue&type=template&id=386f5100&scoped=true"
import script from "./ReturnRefund.vue?vue&type=script&lang=js"
export * from "./ReturnRefund.vue?vue&type=script&lang=js"
import style0 from "./ReturnRefund.vue?vue&type=style&index=0&id=386f5100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f5100",
  null
  
)

export default component.exports